import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import UI from '../0-ui';

// ----------- //
// MESSAGE BOX //
// ----------- //
UI.MsgBox = {
    mOK: 1,
    mCANCEL: 2,
    mYESNO: 4,
    mFRONTEND: 8,
    wYESNO: 16,

    buttons: 1,
    window: null,
    cbAccept: 0,
    cbReject: 0,

    texts: {
        'de': {
            'notice': 'Meldung',
            'ok': 'Ok',
            'yes': 'Ja',
            'no': 'Nein',
            'cancel': 'Abbrechen'
        },
        'en': {
            'notice': 'Notice',
            'ok': 'Ok',
            'yes': 'Yes',
            'no': 'No',
            'cancel': 'Cancel'
        },
        'es': {
            'notice': 'Aviso',
            'ok': 'Ok',
            'yes': 'Sí',
            'no': 'No',
            'cancel': 'Cancelar'
        },
        'fr': {
            'notice': 'Avis',
            'ok': 'Ok',
            'yes': 'Oui',
            'no': 'Non',
            'cancel': 'Annuler'
        },
        'nl': {
            'notice': 'Meldung',
            'ok': 'Ok',
            'yes': 'Ja',
            'no': 'Nee',
            'cancel': 'Annuleren'
        },
        'pt': {
            'notice': 'Aviso',
            'ok': 'Ok',
            'yes': 'Sim',
            'no': 'Não',
            'cancel': 'Cancelar'
        },
        'sv': {
            'notice': 'Meddelande',
            'ok': 'Ok',
            'yes': 'Ja',
            'no': 'Nej',
            'cancel': 'Avbryt'
        },
        'bg': {
            'notice': 'Известие',
            'ok': 'Ok',
            'yes': 'Да',
            'no': 'Не',
            'cancel': 'Отказ'
        }
    },

    show: function (text, mode, onAccept, onReject) {
        if (UI.MsgBox.window != null) return;

        if (!mode) mode = UI.MsgBox.mOK;

        var lang = UI.getLanguage();
        if (!(lang in UI.MsgBox.texts)) {
            lang = 'en';
        }

        var title = 'Info';

        if (mode & UI.MsgBox.mYESNO) title = (this.texts[lang] && this.texts[lang]['notice']) || this.texts['en']['notice'];
        if (mode & UI.MsgBox.wYESNO) title = (this.texts[lang] && this.texts[lang]['notice']) || this.texts['en']['notice'];

        var params = {
            id: 'lp-popup',
            title: title,
            dialogClass: mode & UI.MsgBox.mFRONTEND ? ' pollHeader' : '',
            modal: true,
            stack: true,
            autoOpen: true,
            closeOnEscape: true,
            draggable: true,
            resizable: false,
            // width         : '450px',
            width: '650px',
            open: function () {
                UI.MsgBox.onOpen();
            },
            close: function () {
                UI.MsgBox.onClose();
            },
            closeText: 'x'
        };

        var content = $('<div>' + text + '<br/><br/></div>').css({padding: '10px'});
        var buttons = $('<div class="buttons"></div>');

        if (mode & UI.MsgBox.mOK) {
            var bOK = $('<span class="button submit"><i class="check icon"></i>' + this.texts[lang]['ok'] + '</span>').click(UI.MsgBox.onOk);
            buttons.append(bOK);
        }

        if (mode & UI.MsgBox.mYESNO) {
            var bNo = $('<span class="ui text cancel button"><i class="icon-cancel-5"></i>' + this.texts[lang]['no'] + '</span>').click(UI.MsgBox.onCancel);
            var bYes = $('<span class="button submit"><i class="check icon"></i>' + this.texts[lang]['yes'] + '</span>').click(UI.MsgBox.onOk);
            buttons.append(bNo);
            buttons.append(bYes);
        }

        if (mode & UI.MsgBox.wYESNO) {
            var bNo = $('<span class="ui text cancel button"><i class="icon-cancel-5"></i>' + this.texts[lang]['no'] + '</span>').click(UI.MsgBox.onCancel);
            var bYes = $('<span class="button submit warning"><i class="check icon"></i>' + this.texts[lang]['yes'] + '</span>').click(UI.MsgBox.onOk);
            buttons.append(bNo);
            buttons.append(bYes);
        }

        if (mode & UI.MsgBox.mCANCEL) {
            var bCANCEL = $('<span class="ui text cancel button"><i class="icon-cancel-5"></i>' + this.texts[lang]['cancel'] + '</span>').click(UI.MsgBox.onCancel);
            buttons.append(bCANCEL);
        }

        buttons.css({bottom: '8px', right: '2px', width: '100%', textAlign: 'right'});
        $('.button', buttons).button().css({margin: '0 4px 0 4px'});

        content.append(buttons);

        UI.MsgBox.cbAccept = onAccept;
        UI.MsgBox.cbReject = onReject;
        UI.MsgBox.window = $('<div id="lp-popup"></div>');
        UI.MsgBox.window.append(content);
        UI.MsgBox.window.appendTo('body').dialog(params);
    },

    close: function () {
        var msgbox = $('#lp-popup');
        try {
            msgbox.dialog('destroy');
        } catch (er) { /* empty */
        }
        try {
            msgbox.empty().remove();
        } catch (er) { /* empty */
        }

        UI.MsgBox.window = null;
    },

    onOk: function () {
        UI.MsgBox.close();
        if (is_function(UI.MsgBox.cbAccept)) UI.MsgBox.cbAccept();

    },

    onCancel: function () {
        UI.MsgBox.close();
        if (is_function(UI.MsgBox.cbReject)) UI.MsgBox.cbReject();
    },

    onOpen: function () {
        return true;
    },

    onClose: function () {
        UI.MsgBox.close();
        return true;
    }
};